<template>

  <div class="p-fluid report-field">
    <div class="p-grid">
      <div class="p-col p-pt-0 p-pb-0 p-d-flex p-ai-center" style="line-height: 1rem;">
        <label :for="guide.key">{{$t('report.'+section+'.'+guide.key)}}</label>
      </div>
      <div class="p-col-fixed p-d-flex p-ai-center">
        <Checkbox v-model="checked" :binary="true" :disabled="overview || guide.disabled" :inputId="guide.key"
          @input="dataChanged" :class="{'p-invalid':guide.invalid}"/>
      </div>
    </div>
    <div>

      <Textarea v-if="!overview && guide.annotation" v-model="annotation" rows="2" cols="30" 
        :placeholder="$t('report.annotation_ph')"
        :disabled="guide.disabled"
        @input="annotationChanged($event.target.value)" :aria-label="$t('report.annotation_ph')"/>

      <span v-else-if="overview">{{ annotation ?? '-' }}</span>

    </div>
  </div>

</template>

<script>
export default {
  emits: ['update:data'],
  components: {
  },
  props: {
      section: String,
      guide: Object,
      data: Object,
      overview: Boolean
    },
  data() {
    return {
      checked: false,
      annotation: null
    }
  },
  computed: {
  },
  created() {
    this.checked = this.data[this.guide.key];
    this.annotation = this.data[this.guide.annotation];
  },
  mounted() {
  },
  watch: {
    'guide.disabled': 'resetField',
    'guide.hidden': 'resetField',
  },
  methods: {
    dataChanged(newValue) {
      this.$emit("update:data", { key: this.guide.key, value: newValue });
    },
    annotationChanged(newValue) {
      this.$emit("update:data", { key: this.guide.annotation, value: newValue });
    },
    resetField() {
      if(this.guide.hidden || this.guide.disabled) {
        this.checked = null;
        this.annotation = null;
      }
    }
  }
}
</script>

<style scoped>

</style>